/**
 * フォントサイズ定義（rem）
 */
export const FONT_SIZE = {
  XXS: "0.7rem",
  XS: "0.75rem",
  SM: "0.875rem",
  BASE: "1rem",
  LG: "1.125rem",
  XL: "1.25rem",
  XXL: "1.5rem",
};
